import { render, staticRenderFns } from "./HomeStartUp.vue?vue&type=template&id=68aae295&"
import script from "./HomeStartUp.vue?vue&type=script&lang=js&"
export * from "./HomeStartUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports